// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flowLegend {
    border: 1px solid #eee;
    width: fit-content;
    margin-bottom: 10px;
    padding: 0px 10px;
}


`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/flow-legend/basic-flow-legend/styles.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".flowLegend {\n    border: 1px solid #eee;\n    width: fit-content;\n    margin-bottom: 10px;\n    padding: 0px 10px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flowLegend": `flowLegend`
};
export default ___CSS_LOADER_EXPORT___;
